// A locality can be either a village or neighorhood in the Netherlands
export interface Locality extends ApiEntity {
  name: string
  localityType: 'village' | 'neighborhood'
}

export function fetchLocalities() {
  return useJsonApiFetch<Locality[]>('/api/v1/localities')
}
